export default "__VITE_ASSET__aSn1VM9z__"